<template>
  <div class="preferences-basic" :class="{ invite: invite }">
    <div class="preferences-basic__info" :class="{ invite: invite }">
      <div class="preferences-basic__avatar">
        <BaseAvatar :name="name" large />
      </div>
      <div class="preferences-basic__content">
        <div class="preferences-basic__name">{{ invite ? currentUser.tenantName : name }}</div>
        <input type="hidden" :value="currentUser.email" name="email" />
        <div class="preferences-basic__email">{{ currentUser.email }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseAvatar from '@/components/base/BaseAvatar';
import DateMixin from '@/mixins/date-mixin';
import { getDhm, formatDate, toMoment } from '@/util/date-util';

export default {
  name: 'PreferencesBasicInfo',
  mixins: [DateMixin],
  components: {
    BaseAvatar,
  },
  props: {
    currentUser: Object,
    invite: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    formatDate,
    toMoment,
    getDhm,
  },
  computed: {
    name() {
      return this.invite ? '' : this.currentUser.firstName + ' ' + this.currentUser.lastName;
    },
  },
};
</script>

<style lang="scss">
.preferences-basic {
  background: $color-white;
  box-shadow: $shadow-dropdown;
  margin-bottom: 3px;
  border-radius: $border-radius-root $border-radius-root 0px 0px;

  &__avatar {
    padding-right: 28px;
  }

  &__info {
    padding: 24px 32px;
    align-self: center;
    display: flex;
    width: 100%;

    &.invite {
      padding: 25px;
    }
  }

  &.invite {
    margin-top: 32px;
    margin-bottom: 16px;
  }

  &__content {
    align-self: center;
  }

  &__name {
    font-weight: bold;
    font-size: 20px;
  }

  &__email {
    align-self: center;
    margin-top: 4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    max-width: 250px;
  }

  &.invite {
    background: $color-white;
    box-shadow: $shadow-dropdown;
    border-radius: $border-radius-root;
    display: flex;
  }

  @media screen and (max-width: 1300px) {
    &__email {
      max-width: 210px;
    }
  }
}
</style>
